import { useEffect, useState, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { setUserFacingMutationErrorHandler } from '../lib/queryClient';
import { FeedbackSnackbar } from './FeedbackSnackbar';

export function MutationErrorToast(): ReactElement {
    const { t } = useTranslation();
    const [message, setMessage] = useState<string | null>(null);

    useEffect(() => {
        setUserFacingMutationErrorHandler((messageKey) => setMessage(t(messageKey)));
        return (): void => {
            setUserFacingMutationErrorHandler(undefined);
        };
    }, [t]);

    return (
        <FeedbackSnackbar
            open={message !== null}
            severity="error"
            message={message ?? ''}
            onClose={() => setMessage(null)}
        />
    );
}
